import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#e3760a",
      d: "M10.779 3.26a3 3 0 0 1 2.441 0c.548.244.94.689 1.271 1.158s.702 1.111 1.146 1.882l4.85 8.4 1.057 1.934c.24.521.431 1.083.368 1.68a3 3 0 0 1-1.221 2.113c-.485.353-1.066.469-1.638.521-.577.053-1.313.052-2.202.052H7.148c-.889 0-1.625.001-2.202-.052-.571-.052-1.152-.169-1.638-.521a3 3 0 0 1-1.221-2.113c-.063-.597.128-1.158.368-1.68s.612-1.163 1.057-1.934l4.851-8.401L9.51 4.418c.331-.469.721-.914 1.269-1.158zm1.628 1.827a1 1 0 0 0-.815 0c-.045.02-.179.101-.45.484s-.583.924-1.047 1.728L5.245 15.7l-.973 1.771c-.197.427-.2.583-.195.633a1 1 0 0 0 .407.705c.04.029.177.104.645.146S6.22 19 7.148 19h9.703l2.019-.044c.468-.043.605-.117.645-.146a1 1 0 0 0 .407-.705c.005-.05.002-.206-.195-.633s-.508-.967-.973-1.771l-4.85-8.4-1.048-1.728c-.271-.383-.404-.465-.45-.485zM11 13V9a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0zm2.051 3.1a1 1 0 0 1-.998 1l-.101.001a1 1 0 0 1-1.002-1V16a1 1 0 0 1 1-1h.101a1 1 0 0 1 1 1v.1z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "warning-triangle"}) } }